import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class PropertySettingPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.propertySettingRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.propertySettingImport,
    );
    this.propertySettingAutocomplete = permissionChecker.match(
      Permissions.values.propertySettingAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.propertySettingCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.propertySettingEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.propertySettingDestroy,
    );
  }
}
